'use client'

import Button from "@/components/button/Button";
import Field from "@/components/form/Field";
import Form from "@/components/form/Form";
import ApiUtils from "@/utils/ApiUtils";

const { forwardRef, useImperativeHandle, useRef, useState } = require("react");

const OTPConfirmationForm = forwardRef((props, ref) => {
  
  const [params,setParams] = useState(props.params)
  const [otp,setOtp] = useState('')
  const [otpResult,setOtpResult] = useState({})
  const [message,setMessage] = useState()
  
  const isValid = () => {
    return otp && otp.length == 6
  }
  
  const onFieldChange = (value) => {
    setOtp(value)
  }
  
  const onSubmit = (e) => {
    const payload = { access_key: params.access_key, otp: otp }
    ApiUtils.postRequest("/console/api/users/register", payload)
    .then(data => {
      if (data.error) {
        setOtpResult(data)
      } else {
        if (props.onConfirm) props.onConfirm(data)
      }
    })
  }

  const sendOtp = (e) => {
    e.preventDefault()
    ApiUtils.postRequest("/console/api/users/send_otp", { email: props.email, site: props.site.site_id })
    .then(data => {
      setMessage("New code sent")
    })
  }
  
  useImperativeHandle(ref, () => ({
  }))
  
  return <Form id="otp_confirmation" name="Confirm OTP" onSubmit={e => onSubmit(e)}>
    <Field type="hidden" name="access_key" value={params?.access_key || ''}></Field>
    <div className="sections">
      <section>
        We have sent a confirmation code to your email. Please enter it below to continue.
      </section>
      { otpResult.error &&
      <section className="text-bold text-red">
        { otpResult.message }
      </section>
      }
      <section>
        <Field type="text" name="otp" value={otp} label="OTP Code" noLabel={true} onChange={v => onFieldChange(v)}></Field>
      </section>
      <section>
        <Button theme="primary" type="submit" label="Continue" disabled={!isValid()}></Button>
      </section>
      <section>
        <div className="flex-row flex-with-gap">
          <div className="flex-col">
            <Button theme="plain" label={'Resend code'} onClick={e => sendOtp(e)}></Button>
          </div>
          <div className="flex-col">
            <Button theme="plain" label={'Change email'} onClick={e => props.onConfirm({})}></Button>
          </div>
        </div>
      </section>
      { message &&
      <section className="text-bold text-primary">
        {"->"} { message }
      </section>
      }
    </div>
  </Form>
  
})

OTPConfirmationForm.displayName = "OTPConfirmationForm";
export default OTPConfirmationForm;